import { ISite } from '@wiot/shared-domain/models/settings/settings';
import { SiteSettingsActionTypes } from '../types';
import { SET_SITE_SETTINGS } from '../constants/actionTypes';

export const setSiteSettings = (settings: ISite): SiteSettingsActionTypes => ({
  type: SET_SITE_SETTINGS,
  payload: settings,
});
